import { render, staticRenderFns } from "./ErpDlsOrderBeizhu.vue?vue&type=template&id=e33ae012&scoped=true&"
import script from "./ErpDlsOrderBeizhu.vue?vue&type=script&lang=js&"
export * from "./ErpDlsOrderBeizhu.vue?vue&type=script&lang=js&"
import style0 from "./ErpDlsOrderBeizhu.vue?vue&type=style&index=0&id=e33ae012&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33ae012",
  null
  
)

export default component.exports